// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--h0Tfo","normal":"Button-module--normal--1aHqX","large":"Button-module--large--u9vXa","icon":"Button-module--icon--For-2"};